import Landing from './LandingContainer'

export default Landing



// WEBPACK FOOTER //
// ./src/components/Landing/index.js